// extracted by mini-css-extract-plugin
export var fullWidthButton = "_hg-0";